import { EntityComponentClassExtension, Scope } from '@celum/core/extensions';
import { ListItem } from '@celum/internal-components/list-basics';

export abstract class CardItemExtension<ENTITY> implements EntityComponentClassExtension<ENTITY> {
  public static type = 'CardItemExtension';

  public abstract getScope(): Scope;

  public abstract getComponentClass(entity: ENTITY): ListItem;

  public abstract getIdentifier(): string;

  public getTypeIdentifier(): string {
    return CardItemExtension.type;
  }
}
